import React, { Fragment } from 'react'
import SelectReport from './select-report'

const RenderReport = ({ setCurrentReport, resetCurrentReport, currentReport, reports, gov_id, record_type }) => (

  <Fragment>
    <SelectReport setCurrentReport={setCurrentReport} currentReport={currentReport} reports={reports} />

    {
      (currentReport && currentReport.component) ?
        React.createElement(currentReport.component, {
          gov_id,
          record_type,
          resetCurrentReport,
        }) :
        null
    }

  </Fragment>
)

export default RenderReport


// WEBPACK FOOTER //
// ./src/reports/views/index.jsx